<h1 mat-dialog-title>
  {{ modelRecived ? 'Editar Perfiles Optimos POP' : 'Agregar Perfiles Optimos POP' }}
</h1>

<form [formGroup]="form" (submit)="modelRecived ? update(form.value) : create(form.value)" appPermissionControl="P161F0001">
  <div mat-dialog-content>
    <mat-grid-list [cols]="breakpoint" rowHeight="90px" (window:resize)="onResize($event)">
      <mat-grid-tile>
        <ng-container>
          <mat-form-field class="largoFm" color="accent" appearance="outline">
            <mat-label>Clave</mat-label>
            <input matInput required placeholder="123" formControlName="clavePerfil" type="text" [readonly]="modelRecived" appPermissionControl="P161K0001" />
          </mat-form-field>
        </ng-container>
      </mat-grid-tile>

      <mat-grid-tile>
        <ng-container>
          <mat-form-field class="largoFm" color="accent" appearance="outline">
            <mat-label>Descripción</mat-label>
            <input matInput required placeholder="Ejemplo..." formControlName="descripcion" type="text" appPermissionControl="P161K0002" />
          </mat-form-field>
        </ng-container>
      </mat-grid-tile>

      <mat-grid-tile>
        <ng-container>
          <mat-form-field class="largoFm" color="accent" appearance="outline">
            <mat-label>Score Inicial</mat-label>
            <input matInput required placeholder="123" formControlName="scoreInicial" type="number" appPermissionControl="P161K0003" />
          </mat-form-field>
        </ng-container>
      </mat-grid-tile>

      <mat-grid-tile *ngIf="modelRecived">
        <ng-container>
          <button mat-raised-button type="button" color="accent" (click)="openVariables()" style="margin-right: 10px" appPermissionControl="P161B0001">
            <mat-icon>format_list_bulleted</mat-icon> Variables
          </button>

          <button mat-raised-button type="button" color="accent" (click)="openAuditar()" appPermissionControl="P161B0002"><mat-icon>network_check</mat-icon> Auditar</button>
        </ng-container>
      </mat-grid-tile>
    </mat-grid-list>
  </div>

  <div mat-dialog-actions>
    <ng-container *ngIf="!loading"
      ><button class="botonFm btn-cancel" type="button" mat-raised-button (click)="close()" appPermissionControl="P161B0003">Cancelar</button>
      <button class="botonFm" mat-raised-button color="accent" appPermissionControl="P161B0004">
        {{ modelRecived ? 'Actualizar' : 'Guardar' }}
      </button>
    </ng-container>
    <button *ngIf="loading" class="botonGrandeFm" mat-raised-button color="accent" type="button" appPermissionControl="P161B0005">
      Cargando
      <mat-progress-bar mode="buffer"></mat-progress-bar>
    </button>
  </div>
</form>
